import { Link } from 'react-router-dom';
import LegalPage, { Section } from './LegalPage';

export default function ComplaintsPage() {
  return (
    <LegalPage
      title="Complaints & Disputes"
      intro="We aim to resolve every concern fairly and quickly. If something has gone wrong, here is how to raise it with us."
    >
      <Section heading="Step 1 — Contact support">
        <p>
          Most issues are resolved fastest by contacting our support team. Please include your account
          email, the date and time of the issue, and any relevant bet or transaction reference.
        </p>
        <p>
          Email:{' '}
          <a
            href="mailto:support@sports-betting.my-investments.io"
            className="font-semibold text-primary hover:underline"
          >
            support@sports-betting.my-investments.io
          </a>
        </p>
      </Section>

      <Section heading="Step 2 — Formal complaint">
        <p>
          If you are not satisfied with the first response, ask for your complaint to be escalated. We
          will acknowledge a formal complaint and aim to provide a final written response within a
          reasonable period.
        </p>
      </Section>

      <Section heading="Step 3 — External resolution">
        <p>
          If we cannot resolve your complaint to your satisfaction, you may refer the matter to the
          relevant provincial gambling regulator. Details will be provided in our final response.
        </p>
      </Section>

      <Section heading="Need help with gambling itself?">
        <p>
          If your concern relates to gambling becoming a problem, please see our{' '}
          <Link to="/responsible-gambling" className="font-semibold text-primary hover:underline">
            Responsible Gambling
          </Link>{' '}
          page or call the free helpline on{' '}
          <a href="tel:0800006008" className="font-semibold text-primary hover:underline">
            0800 006 008
          </a>
          .
        </p>
      </Section>
    </LegalPage>
  );
}
